export default __webpack_public_path__ + "static/media/Button_2-min.058f3472.png";